import DateTab from '@/src/components/common/dateTab'
import { Box } from '@mui/material'
import React, { useEffect, useRef } from 'react'

export interface DateItem {
    date: string
    day: string
    price: string
    isSelected: boolean
    isLowest: boolean
}

interface MobileDateCarouselProps {
    dates: DateItem[]
    onSelect: (index: number) => void
    selectedIndex: number
}

const MobileDateCarousel: React.FC<MobileDateCarouselProps> = ({ dates, onSelect, selectedIndex }) => {
    const targetedScrollDateRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        targetedScrollDateRef?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
        })
    }, [])

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                minHeight: 64,
                bgcolor: 'background.paper'
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 64
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        overflowX: 'auto',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        px: 1,
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': { display: 'none' },
                        boxSizing: 'border-box',
                        // Add smooth scrolling behavior
                        scrollBehavior: 'smooth',
                        // Enable momentum scrolling on iOS
                        WebkitOverflowScrolling: 'touch',
                        // Add some scroll physics
                        '& > *': {
                            transition: 'transform 0.2s ease-out'
                        }
                    }}
                >
                    {dates.map((item, index) => (
                        <Box
                            key={`${item.date}-${index}`}
                            sx={{
                                flexShrink: 0,
                                mr: 1
                            }}
                            ref={index - 2 === selectedIndex ? targetedScrollDateRef : undefined}
                        >
                            <DateTab
                                date={item.date}
                                day={item.day}
                                price={item.price}
                                isSelected={item.isSelected}
                                isLowest={item.isLowest}
                                onClick={() => onSelect(index)}
                                variant="mobile"
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default MobileDateCarousel
